import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter, useParams } from 'react-router-dom';

import { create as createTeam } from 'js/actions/team-actions';

import CreateTeamComponent from '../components/CreateTeamComponent';

function CreateTeamContainer({ createTeam, history }) {
  const { workspaceId } = useParams();

  const handleSave = useCallback(
    (newTeam) => {
      const team = {
        ...newTeam,
        workspace_id: workspaceId,
      };

      createTeam(team).then((newTeam) => {
        history.push(`/w/${team.workspace_id}/teams/${newTeam.id}/dashboard`);
      });
    },
    [createTeam, history, workspaceId]
  );

  return <CreateTeamComponent onSave={handleSave} />;
}

export default withRouter(
  connect(() => ({}), {
    createTeam,
  })(CreateTeamContainer)
);
